import moment from "moment-timezone";

// 屆次切換設定 (與後端保持一致)
export const SESSION_SWITCH_MONTH = 4;  // 4 月
export const SESSION_SWITCH_DAY = 21;   // 21 日

/**
 * 取得目前的挑戰屆次年份
 * 分界點: 每年 04/21 00:00:00 (台北時間)
 * @returns {number} 屆次年份
 */
export function getCurrentSessionYear() {
	const now = moment().tz("Asia/Taipei");
	const threshold = moment.tz(
		`${now.year()}-${String(SESSION_SWITCH_MONTH).padStart(2, '0')}-${String(SESSION_SWITCH_DAY).padStart(2, '0')} 00:00:00`,
		"Asia/Taipei"
	);
	return now.isSameOrAfter(threshold) ? now.year() + 1 : now.year();
}
